import { useMemo } from "react";
import { useHseSummary } from "@dashboard/hooks/useHseSummary";

export type IssueCategoryData = {
    area: string;
    deviations: number;
    percentage: number;
};

export function useIssuesCategoryMetrics() {
    const { data: hseSummary, isLoading, error } = useHseSummary();

    const metrics = useMemo(() => {
        const raw = hseSummary?.metricsIssueByCustomer?.issues_by_categories;
        const issuesByCategory = Array.isArray(raw) ? {} : (raw ?? {});
        const entries = Object.entries(issuesByCategory);
        const totalDeviations = entries.reduce((sum, [, count]) => sum + count, 0);
        const totalCategories = entries.length;

        const highestCategory =
            entries.length > 0
                ? entries.reduce((max, current) => (current[1] > max[1] ? current : max))
                : null;

        const tableData: IssueCategoryData[] = entries.map(([category, count]) => ({
            area: category,
            deviations: count,
            percentage: totalDeviations > 0 ? (count / totalDeviations) * 100 : 0,
        }));

        return {
            tableData,
            totalDeviations,
            totalCategories,
            highestCategoryName: highestCategory ? highestCategory[0] : "-",
            highestCategoryPercentage:
                highestCategory && totalDeviations > 0
                    ? (highestCategory[1] / totalDeviations) * 100
                    : 0,
        };
    }, [hseSummary]);

    return {
        ...metrics,
        isLoading,
        error,
    };
}
